import React from 'react';
import Button from 'Components/Button';

export default function BrandsList({ list, isInternalUser, addBrand, editBrand, deleteBrand, isInspector }) {
  if (isInspector && !list.length) return null;

  return (
    <section className='scene_section _padding_top_15 _padding_bottom_20'>
      <header>Brands</header>
      {!isInternalUser && (
        <div className='scene_section_subheader'>
          <div className='__attention-icon'></div>
          <div className='_margin_left_10'>{'Please contact NMMA if you don\'t see any of your brands below.'}</div>
        </div>
      )}
      {!!list.length && (
        <React.Fragment>
          <div className='list__wrapper _margin_top_20'>
            <div className='list__row list__header list__header_small'>
              <div className='list__row-item list__header-item_small list__row-item_place-filler'>Brand Name</div>
              {isInternalUser && (
                <div className='list__row-item list__header-item_small _width_pc_20'>Website Address</div>
              )}

              {isInternalUser && <div className='list__row-item list__header-item_small _width_pc_20'>Boat Type</div>}

              {isInternalUser && (
                <div className='list__row-item list__header-item_small _width_pc_10 _text_align_center'>Edit</div>
              )}

              {isInternalUser && (
                <div className='list__row-item list__header-item_small _width_pc_10 _text_align_center'>Delete</div>
              )}
            </div>

            {list.map((ListItem, index) => (
              <div className='list__row list__row_small' key={index}>
                <a
                  className={'list__row-item list__row-item_small list__row-item_place-filler'}
                  href={ListItem.web}
                  target='_blank'
                  rel="noreferrer"
                >
                  {`${index + 1}. ${ListItem.name}`}
                </a>

                {isInternalUser && (
                  <div className='list__row-item list__row-item_small _width_pc_20'>{ListItem.web}</div>
                )}

                {isInternalUser && (
                  <div className='list__row-item list__row-item_small _width_pc_20'>{ListItem.boatType}</div>
                )}

                {isInternalUser && (
                  <div className='list__row-item list__header-item_small list__row-item_component _width_pc_10'>
                    <div className='_download-icon' onClick={editBrand(ListItem)} />
                  </div>
                )}

                {isInternalUser && (
                  <div className='list__row-item list__header-item_small list__row-item_component _width_pc_10'>
                    <div className='__remove-icon' onClick={deleteBrand(ListItem.id)} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </React.Fragment>
      )}

      {isInternalUser && (
        <Button label='+ Add Brand' buttonClassName='_height_40 _width_160 _margin_top_20' onClick={addBrand} />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/SummaryScene/BrandsList.jsx